import {
  DefaultButton,
  IDropdownOption,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { useSoftwarePackageVersions } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SoftwarePackageVersionDropDown } from "../../../common/SoftwarePackageVersionDropDown";
import { SelectSoftwarePackageFormValues } from "../../../rings/rollout-package/add/selectSoftwarePackageUtils";

interface SoftwarePackageDetailsProps {
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedSoftwarePackage: React.Dispatch<
    React.SetStateAction<SelectSoftwarePackageFormValues>
  >;
  softwarePackage: SelectSoftwarePackageFormValues;
}

export const SoftwarePackageDetails: React.FC<SoftwarePackageDetailsProps> = ({
  setShowDialog,
  softwarePackage,
  setSelectedSoftwarePackage
}) => {
  const theme = useTheme();

  const { data: softwarePackageVersions } = useSoftwarePackageVersions({
    softwarePackageId: softwarePackage.softwarePackageId
  });

  const versionOptions =
    softwarePackageVersions?.map(x => {
      return {
        key: x.id,
        text: x.version as string,
        data: x
      } as IDropdownOption;
    }) ?? [];

  return (
    <Stack
      horizontal
      tokens={{ childrenGap: theme.spacing.l2 }}
      styles={{
        root: {
          borderColor: theme.semanticColors.variantBorder,
          borderWidth: 1,
          borderStyle: "solid",
          padding: theme.spacing.s1,
          justifyContent: "space-between"
        }
      }}
    >
      <Stack>
        <Text variant="large">{softwarePackage.displayName}</Text>
        <Text variant="small">Description: {softwarePackage.description}</Text>
        <Text variant="small">Code: {softwarePackage.code}</Text>
        <SoftwarePackageVersionDropDown
          selectedKey={softwarePackage.softwarePackageVersionId}
          name="softwarePackageVersionId"
          label="Version"
          options={versionOptions}
          styles={{ root: { maxWidth: "30%" } }}
          onChange={(_, option) =>
            setSelectedSoftwarePackage({
              ...softwarePackage,
              softwarePackageVersionId: String(option?.key)
            })
          }
        />
      </Stack>

      <DefaultButton
        iconProps={{ iconName: "Edit" }}
        onClick={() => {
          setShowDialog(true);
        }}
        text="Change Software Package"
        styles={{ root: { height: "fit-content" } }}
      />
    </Stack>
  );
};
